module.exports = __webpack_public_path__ + "img/truckFrontRight.f7c98937.svg";